import { render } from "./DarkMode.vue?vue&type=template&id=6706bb26"
import script from "./DarkMode.vue?vue&type=script&lang=js"
export * from "./DarkMode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__